import actions from '../constants/actionTypes';

const initialState = {
  isReady: false,
  isLoading: false,
  isSidebarCollapse: false,
  metadata: null,
  nowPortalMetadata: null,
  tableMetaData: null,
  restaurants: [],
  merchantTableInfos: [],
  setting: {},
};

function appReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FINISH_INIT_APP: {
      return {
        ...state,
        isReady: true,
      };
    }
    case actions.START_APP_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case actions.STOP_APP_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case actions.GET_META_DATA: {
      const { metadata } = action.response;
      return {
        ...state,
        metadata,
      };
    }
    case actions.RECEIVE_NOW_PORTAL_META_DATA: {
      const { metadata } = action.response;
      return {
        ...state,
        nowPortalMetadata: metadata,
      };
    }
    case actions.SET_LIST_RESTAURANT: {
      const { restaurants } = action.response;
      return {
        ...state,
        restaurants,
      };
    }
    case actions.SET_SIDEBAR_COLLAPSE: {
      return {
        ...state,
        isSidebarCollapse: action.response,
      };
    }

    case actions.RECEIVE_LIST_TABLE_RESTAURANTS: {
      const { merchantTableInfos = [] } = action.response;
      return {
        ...state,
        merchantTableInfos,
      };
    }

    case actions.SET_SETTING_USER: {
      const { setting } = action.response;
      return {
        ...state,
        setting,
      };
    }

    case actions.TABLE_META_DATA_RECEIVED: {
      const { response } = action;
      return {
        ...state,
        tableMetaData: response.reply.metadata,
      };
    }

    default:
      return state;
  }
}

export default appReducer;



// WEBPACK FOOTER //
// ./foody/src/layout/reducers.js